<template>
  <div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <Summary :data="summary" />
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <reasons-discard :series="seriesM" />
        </div>
      </div>
    </div>
    <div class="grid gap-y-6 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <harvest-monthly :data="harvests_monthly" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <accepted-discarded :data="totals_monthly" :summary="summary" />
        </div>
      </div>
      <div class="panel" v-if="Object.keys(crop_sizes).length > 1">
        <div class="panel-body">
          <crop-sizes :data="crop_sizes" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Summary from "@/components/views/organization/production/query_by_producers/charts/Summary.vue";
import ReasonsDiscard from "@/components/views/organization/production/query_by_producers/charts/ReasonsDiscard.vue";
import HarvestMonthly from "@/components/views/producer/reporting/process/charts/HarvestMonthly.vue";
import AcceptedDiscarded from "@/components/views/organization/production/query_by_producers/charts/AcceptedDiscarded.vue";
import CropSizes from "@/components/views/producer/reporting/process/charts/CropSizes.vue";
export default {
  name: "PRODReportingProcessShowReportsSummary",
  components: {
    Summary,
    ReasonsDiscard,
    HarvestMonthly,
    AcceptedDiscarded,
    CropSizes
  },
  props: {
    producer_id: { required: true },
    provider_type: { required: true },
    harvest_process_id: { required: true },
    summary: { required: true },
    harvests_monthly: { required: true },
    totals_monthly: { required: true },
    crop_sizes: { required: true }
  },
  data() {
    return {
      // Motivos descarte
      seriesM: [40, 30, 15, 10, 5]
    };
  },
};
</script>
